// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PickTrip_wrapper__1U8UL","background":"PickTrip_background___KQ-L","cardWrapper":"PickTrip_cardWrapper__1X0Fe"};